import { cn } from '../../lib/utils';

export type LangKey = 'en' | 'rw' | 'fr';

export function LangTabs({ active, onChange }: { active: LangKey; onChange: (l: LangKey) => void }) {
  return (
    <div className='flex gap-0.5 bg-gray-100 rounded-lg p-0.5 w-fit'>
      {(['en', 'rw', 'fr'] as const).map(l => (
        <button
          key={l} type='button' onClick={() => onChange(l)}
          className={cn(
            'px-2.5 py-1 text-xs font-semibold rounded-md transition-all',
            active === l ? 'bg-white shadow text-gray-900' : 'text-gray-400 hover:text-gray-700'
          )}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
